<script>
import {
  UserProfilePageElementMixin,
} from "%/dynamic-component-editor/standard-pages/user-profile-page/user-profile-page-element-mixin";
import { mapState } from "pinia";
import useFanPublicationStore from "%/dynamic-component-editor/stores/fan-publication-store";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import BaseButtonElement
  from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";

export default {
  name: "MessageButton",
  elementPanelSettings: {
    displayName: "Direct Message",
    elementGroup: "userProfile",
  },
  extends: BaseButtonElement,
  mixins: [UserProfilePageElementMixin],
  computed: {
    ...mapState(useFanPublicationStore, ["fanUrl", "publicationId"]),
    shouldRenderButton() {
      return this.editMode || useConfigurationStore().directMessaging;
    },
  },
  methods: {
    handleButtonClick() {
      window.location.href = `${this.fanUrl}/chat-room?entity_id=${this.entityId}&context=direct_messaging`;
    },
  },
};
</script>

<style scoped lang="scss">
</style>
